<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full content">
                    <div class="pt-4 pb-8 px-5 w-full">
                        <div class="flex justify-end w-full">
                            <div>
                                <img src="@/assets/icon/dialog/close.svg" @click="clickCancel()"/>
                            </div>
                        </div>
                        <div class="flex gap-4 pt-4">
                            <div
                                class="text-center campaign-image rounded-xl flex-none"
                                :style="{ 'background-image': `url('${campaign.fullImageUrl}')` }"
                            ></div>
                            <!-- <div class="text-center campaign-image rounded-xl flex-none">
                                <img class="rounded-xl" :src="campaign.fullImageUrl" />
                            </div> -->
                            <div class="flex flex-col justify-between gap-2">
                                <div class="brand text-primary text-lg line-clamp-2 overflow-hidden">{{ campaign.name }}</div>
                                <div class="text-base text-gray-secondary">{{ getPrivilegeMessage() }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-3.5 px-5 pb-10 w-full">
                        <!-- <div class="text-16 text-primary text-center font-medium">{{ lbl.confirm_used.default }}</div>
                        <div class="text-14 text-red-1 text-center" v-if="campaign.minutesValidAfterUsed > 0">
                            {{ getTextAfterUsed() }}
                        </div> -->
                        <div class="flex justify-center w-full">
                            <SlideToUseButton
                                :text="lbl.confirm_used.slide_to_used"
                                :completedText="lbl.confirm_used.slide_to_used_success"
                                @onSlideCompleted="clickOk"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import SlideToUseButton from "@/components/Button/SlideToUseButton.vue";
import Locale from "@/helper/locale/Locale.js";
//component

export default {
    name: "ConfirmRedeemModal",
    mixins: [LocaleMixin],
    components: {
        SlideToUseButton
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            type: null,
            campaign: null,
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.campaign = config.campaign;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.confirm_redeem.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.confirm_redeem.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        getDateAfterUsed: function () {
            let minutes = this.campaign?.minutesValidAfterUsed;
            if (minutes >= 1440) { // 1 day = 1440 minutes
                const days = Math.floor(minutes / 1440);
                // const remainingMinutes = minutes % 1440;
                // const hours = Math.floor(remainingMinutes / 60);
                return days + ' ' + this.lbl.date.days + (days > 1 && this.localeCode == 1033 ? 's' : '')
            } else if (minutes >= 60) { // 1 hour = 60 minutes
                const hours = Math.floor(minutes / 60);
                // const remainingMinutes = minutes % 60;
                return hours + ' ' + this.lbl.date.hours + (hours > 1 && this.localeCode == 1033 ? 's' : '')
            } else {
                return minutes + ' ' + this.lbl.date.minutes + (minutes > 1 && this.localeCode == 1033 ? 's' : '');
            }
        },
        getTextAfterUsed: function() {
            if (this.campaign.minutesValidAfterUsed > 0) {
                return this.lbl.confirm_used.used_have_time.replace('{0}', this.getDateAfterUsed());
            }
            return '';
        },
        getPrivilegeMessage: function() {
            let message = '';
            let localeCode = Locale.getLocaleCode();
            if (this.campaign && this.campaign.customFacebookMessage) {
                let splitMessage = this.campaign.customFacebookMessage.split('|');
                if (localeCode == 1033) {
                    message = splitMessage[1];
                } else {
                    message = splitMessage[0];
                }
            }
            return message;
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import "@/style/base/image.scss";
    .open.modal {
        justify-content: end;
    }
    .modal {
        @extend %modal;
        .modal-content {
            width: 100%;
            .content {
                border-radius: 20px 20px 0 0 ;
                .campaign-image {
                     @include boxRatio($ratio: 66.66%);
                     width: 120px;
                     max-height: 80px;
                }
            }
        }
    }

</style>
